import type { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    authority: 'https://login.microsoftonline.com/' + import.meta.env.VITE_UENBPQ_TENANT_ID,
    clientId: import.meta.env.VITE_UENBPQ_FRONTEND_CLIENT_ID,
    redirectUri: '/redirect.html',
  },
  cache: {
    cacheLocation: 'localStorage',
  },

  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [`api://${import.meta.env.VITE_UENBPQ_API_CLIENT_ID}/access_as_user`],
};

export const graphConfig = {
  graphMeEndpoint: '',
};
